export default function psa_auth({ next, router, to }) {
    if (!localStorage.getItem('token')) {
        return router.push({ name: 'PsaAuthLogin', params: { slug: to.params.slug } });
    }

    return next();
}